import firebase from "firebase/app";
import { db } from "@/firebase";

export const state = {
  proposals: []
};

export const mutations = {
  ADD_PROPOSAL(state, proposalData) {
    state.proposals.push(proposalData);
  }
};

export const actions = {
  createProposal({ commit, dispatch }, proposalData) {
    // if (proposalData.client == null || proposalData.client == "") {
    //   const notification = {
    //     type: "error",
    //     message: "Select client!"
    //   };
    //   dispatch("notification/add", notification, { root: true });
    //   return;
    // }
    console.log("proposalData - ", proposalData);

    let tempDocRef = db.collection("clients").doc(proposalData.client);
    let newProposalData = { ...proposalData, client: tempDocRef };
    console.log("newProposalData - ", newProposalData);
    db.collection("proposals")
      .add(newProposalData)
      .then(docRef => {
        commit("ADD_PROPOSAL", { id: docRef.id, ...proposalData });
        tempDocRef
          .update({
            proposals: firebase.firestore.FieldValue.arrayUnion(docRef)
          })
          .then(() => {
            const notification = {
              type: "success",
              message: "Proposal added!"
            };
            dispatch("notification/add", notification, { root: true });
          });
      });
  },
  loadAllProposals({ state, commit }) {
    // if (state.proposals.lenght != 0) return;
    state.proposals = [];
    db.collection("proposals")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // console.log(doc.data());
          commit("ADD_PROPOSAL", { id: doc.id, ...doc.data() });
        });
      });
  }
};

export const getters = {
  getAllProposals(state) {
    return state.proposals;
  },
  getPendingProposals(state) {
    return state.proposals.filter(p => p.currentState == 0);
  },
  getApprovedProposals(state) {
    return state.proposals.filter(p => p.currentState == 1);
  },
  getInvoicedProposals(state) {
    return state.proposals.filter(p => p.currentState == 2);
  },
  getFinishedProposals(state) {
    return state.proposals.filter(p => p.currentState == 3);
  },
  getProposalTotal: state => idProposal => {
    let tempP = state.proposals.find(p => p.id == idProposal);
    return tempP.items.reduce((acc, prox) => ({
      value: parseInt(acc.value) + parseInt(prox.value)
    })).value;
  },
  getProposalClient: state => idProposal => {
    let tempP = state.proposals.find(p => p.id == idProposal);
    return tempP.client;
  }
};
